/**
 * Controla o menu que alterna a visualização dos hos do mapa
 *
 * @author Fabio Junior Date: 21/12/2012 Time: 12:11
 */


Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.Map = Greenmile.Toolbar.Map || {};
Greenmile.Toolbar.Map.HOSLayerControl = function (selector, map, options) {

    this.preferenceShowHOS = new Greenmile.Storage.StoreMapPosition().getHOSMapFromUser();

    if (options) {
        this.screenRoute = options.sourceSessionData;
    }

    this.markCheckedByPreferenceUser = function (typeHOS) {

        if (!this.preferenceShowHOS) {

            var storeMapPosition = new Greenmile.Storage.StoreMapPosition();
            this.preferenceShowHOS = storeMapPosition.setHOSMapFromUser();

        }

        if (typeHOS === 'onDuty') {

            return this.preferenceShowHOS.on_duty;

        } else if (typeHOS === 'offDuty') {

            return this.preferenceShowHOS.off_duty;

        } else if (typeHOS === 'break') {

            return this.preferenceShowHOS.break_hos;

        } else if (typeHOS === 'wait') {

            return this.preferenceShowHOS.wait_hos;

        } else if (typeHOS === 'lunch') {

            return this.preferenceShowHOS.lunch;

        } else if (typeHOS === 'driving') {

            return this.preferenceShowHOS.driving;

        }

    };

    this.populateHOSLayerControl = function (hosType) {

        var error = null;

        try {

            if (hosType) {

                var hosTypeLength   = hosType.length,
                    listHOSSelector = selector + " .hos li ul",
                    hosElementHtml  = document.querySelector(listHOSSelector),
                    template        = Greenmile.Toolbar.Map.Layouts["#item_hos_template"],
                    routeReference  = selector.replace(/[^a-zA-Z0-9]/g, "");

                for (var i = 0; i < hosTypeLength; i++) {
                    var model = hosType[i];
                    hosElementHtml.appendChild(template(model.value, model.label, routeReference));
                }

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on populate hos controller.");
            error.console();

        }
    };

    this.getHosEventTypeAndPopulateCheckbox = function () {

        var error = null;
        try {

            var util = Greenmile.HoursOfService.Utils,
                arrayOfEvents;

            arrayOfEvents = util.getArrayEventTypeToHOSLayerControl();

            this.populateHOSLayerControl(arrayOfEvents);

        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                "Error on populate hos controller.");
            error.console();
        }

    };

    this.checkDrawHOSOnMapPreferenceUser = function (eventType) {

        if (this.preferenceShowHOS) {

            if (eventType === 'ON_DUTY') {

                return this.preferenceShowHOS.on_duty;

            } else if (eventType === 'OFF_DUTY') {

                return this.preferenceShowHOS.off_duty;

            } else if (eventType === 'BREAK_START' || eventType === 'BREAK_END') {

                return this.preferenceShowHOS.break_hos;

            } else if (eventType === 'WAIT' || eventType === 'WAIT_START' || eventType === 'WAIT_END') {

                return this.preferenceShowHOS.wait_hos;

            } else if (eventType === 'LUNCH' || eventType === 'LUNCH_START' || eventType === 'LUNCH_END') {

                return this.preferenceShowHOS.lunch;

            } else if (eventType === 'DRIVING' || eventType === 'DRIVING_START' || eventType === 'DRIVING_END') {

                return this.preferenceShowHOS.driving;

            }
        }
        return false;
    };

    this.updatePreferenceHOSUser = function (typeHOS, value) {

        if (typeHOS ==='onDuty') {

            this.preferenceShowHOS.on_duty = value;

        } else if (typeHOS ==='offDuty') {

            this.preferenceShowHOS.off_duty = value;

        } else if (typeHOS ==='break') {

            this.preferenceShowHOS.break_hos = value;

        } else if (typeHOS ==='wait') {

            this.preferenceShowHOS.wait_hos = value;

        } else if (typeHOS ==='lunch') {

            this.preferenceShowHOS.lunch = value;

        } else if (typeHOS ==='driving') {

            this.preferenceShowHOS.driving = value;

        }

        new Greenmile.Storage.StoreMapPosition().setHOSMapFromUser(this.preferenceShowHOS);

    };

    this.addByType = function (hosType) {

        var error = null;

        try {

            if (hosType && this.screenRoute) {

                var hosOfRoute = this.screenRoute.listHos;

                this.updatePreferenceHOSUser(hosType, true);

                if (hosOfRoute) {

                    var mapEvents = new Greenmile.HoursOfService.MapEvents(selector);

                    mapEvents.drawMarkersByType(hosOfRoute, map, hosType);

                }
            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on add by type.");
            error.console();

        }

    };

    this.removeByType = function (hosType) {

        var error = null;

        try {

            var mapEvents = new Greenmile.HoursOfService.MapEvents();
            mapEvents.removeHosOnMap(map, hosType);

            this.updatePreferenceHOSUser(hosType, false);

        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                "Error on remove by type.");
            error.console();
        }

    };

    this.checkEventTypeLayer = function (event) {
        var latitudeIsNotDefined  = typeof event.latitude !== "undefined",
            longitudeIsNotDefined = typeof event.longitude !== "undefined",
            utils                 = Greenmile.HoursOfService.Utils;

        if (latitudeIsNotDefined && longitudeIsNotDefined) {
            const eventName = utils.getEventTypeName(event.eventType);
            const routeReference = selector.replace(/[^a-zA-Z0-9]/g, "");
            const hosLayerCheck = document.querySelector(`${selector} #hos-${eventName}-${routeReference}`);
            if (hosLayerCheck !== null && hosLayerCheck.checked !== true) {
                hosLayerCheck.checked = true;
            }
        }
    };

    this.eventTypeIsChecked = function (eventType) {
        const utils = Greenmile.HoursOfService.Utils;
        const eventName = utils.getEventTypeName(eventType);
        const routeReference = selector.replace(/[^a-zA-Z0-9]/g, "");
        const hosLayerCheck = document.querySelector(`${selector} #hos-${eventName}-${routeReference}`);

        if (hosLayerCheck && hosLayerCheck.checked) {
            return true;
        }

        return false;
    };

    this.clearAllChecks = function () {

        var hosLayersCheck = document.querySelectorAll(selector + " .hos input[type='checkbox']"),
            amountChecks   = 0;

        if (hosLayersCheck) {

            amountChecks = hosLayersCheck.length;

            for (var i = 0; i < amountChecks; i++) {

                if (hosLayersCheck[i].checked) {
                    hosLayersCheck[i].checked = false;
                }
            }

        }
    };

    this.addListeners = function () {

        this.getHosEventTypeAndPopulateCheckbox();

        var error = null;

        try {
            var itemsHosSelector = selector + " .hos input[type=checkbox]",
                itemsHOS         = document.querySelectorAll(itemsHosSelector);

            if (itemsHOS !== null) {
                itemsHOS.forEach((item) => {
                    const hosType = /-(.*)-/.exec(item.id)[1];
                    item.checked = this.markCheckedByPreferenceUser(hosType);
                    item.addEventListener("click", () => {
                        if (item.checked) {
                            this.addByType(hosType);
                        } else {
                            this.removeByType(hosType);
                        }
                    });
                });
            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on add listenners.", e);
            error.console();

        }

    };

};
